import { useEffect, useState } from 'react';
import { fetchAccountBankRelationships } from '@/api/custom';
import type { WalletBankRelationship } from '@/util/bank-link';

export type AttachAllFundingBanksState = {
  relationships: ReadonlyMap<string, readonly WalletBankRelationship[]>;
  failed: ReadonlySet<string>;
};

const EMPTY: AttachAllFundingBanksState = { relationships: new Map(), failed: new Set() };

export const useAttachAllFundingBanks = (
  accountIds: readonly string[],
  reloadKey = 0,
): AttachAllFundingBanksState => {
  const [state, setState] = useState<AttachAllFundingBanksState>(EMPTY);
  const key = [...accountIds].sort().join(',');

  useEffect(() => {
    if (!key) {
      setState(EMPTY);
      return undefined;
    }
    let active = true;
    const ids = key.split(',');
    void Promise.allSettled(ids.map((id) => fetchAccountBankRelationships(id))).then(
      (results) => {
        if (!active) {
          return;
        }
        const relationships = new Map<string, readonly WalletBankRelationship[]>();
        const failed = new Set<string>();
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            relationships.set(ids[index], result.value.bank_relationships ?? []);
          } else {
            failed.add(ids[index]);
          }
        });
        setState({ relationships, failed });
      },
    );
    return () => {
      active = false;
    };
  }, [key, reloadKey]);

  return state;
};

export default useAttachAllFundingBanks;
